import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

const StyledTableContainer = styled(TableContainer)({
    backgroundColor: '#202020',
    borderRadius: '12px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
    overflowX: 'auto',
});

const CompactTableCell = styled(TableCell)({
    padding: '16px 20px',
    fontSize: '1rem',
    color: '#fff',
});

const FacilitiesCity = () => {
    const { country, region } = useParams();
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCities = async () => {
            try {
                console.log(`🔹 Fetching cities for region ${region} in ${country}...`);
                const response = await fetch(`https://api.admin.marsreel.com/api/venue-cities/${country}/${region}`, {
                    method: "GET",
                    headers: { "Cache-Control": "no-cache" },
                });

                if (!response.ok) {
                    throw new Error(`HTTP Error: ${response.status}`);
                }

                const data = await response.json();
                console.log("✅ Fetched Cities:", data);

                if (!Array.isArray(data) || data.length === 0) {
                    setError(`No cities found for ${region}.`);
                    setCities([]);
                    return;
                }

                setCities(data);
            } catch (error) {
                console.error(`❌ Error fetching cities:`, error);
                setError("Failed to load cities. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        fetchCities();
    }, [country, region]);

    return (
        <Box sx={{ color: '#fff' }}>
            <Typography variant="h4" gutterBottom>{region} Cities</Typography>

            {loading && (
                <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <CircularProgress sx={{ color: "#12c099" }} />
                </Box>
            )}

            {error && !loading && (
                <Typography sx={{ textAlign: "center", marginTop: "20px", color: "red" }}>
                    {error}
                </Typography>
            )}

            {!loading && !error && cities.length > 0 && (
                <StyledTableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <CompactTableCell>City</CompactTableCell>
                                <CompactTableCell>Total Facilities</CompactTableCell>
                                <CompactTableCell>View Facilities</CompactTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {cities.map((city) => (
                                <TableRow key={city.name}>
                                    <CompactTableCell>{city.name}</CompactTableCell>
                                    <CompactTableCell>{city.venueCount || 0}</CompactTableCell>
                                    <CompactTableCell>
                                        <Button
                                            component={Link}
                                            to={`/facilities/${encodeURIComponent(country)}/${encodeURIComponent(region)}/${encodeURIComponent(city.name)}`}
                                            sx={{ color: "#12c099", textTransform: "none" }}
                                        >
                                            View Facilities
                                        </Button>

                                    </CompactTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </StyledTableContainer>
            )}
        </Box>
    );
};

export default FacilitiesCity;
